// alert('Hey Nuel');
// console.log('Hello');
// https://www.codehim.com/vanilla-javascript/light-dark-theme-toggle-with-css-and-javascript/#:~:text=The%20JavaScript%20function%20detects%20the,dark%20mode%20will%20be%20activated.

var checkbox = document.querySelector('input[name=theme]');
checkbox.addEventListener('change', function() {
    if(this.checked) {
        trans()
        document.documentElement.setAttribute('data-theme', 'light')
    } else {
        trans()
        document.documentElement.setAttribute('data-theme', 'dark')
    }
})

let trans = () => {
    document.documentElement.classList.add('transition');
    window.setTimeout(() => {
        document.documentElement.classList.remove('transition')
    }, 300)
}

